import React, { useEffect } from 'react';
import Dialog from "../../../atoms/dialog";
import Button from "@material-ui/core/Button";
import { getSelectedNode } from "../../../../store/global/selectors";
import { constructIds } from "../../../../config/common";
import { getClusterlets } from "../../../../store/constructs/clusterlets/selectors";
import { getClusterletConnections } from "../../../../store/constructs/clusterlet_connections/selectors";
import { useSelector, useDispatch } from 'react-redux'
import { deleteClusterlet } from "../../../../store/constructs/clusterlets/actions";
import { deleteClusterletConnection } from "../../../../store/constructs/clusterlet_connections/actions";

import './index.css';
export default function EdgeDeletePopUp({ closePopUp }) {

  const dispatch = useDispatch()
  const clusterlets = useSelector(getClusterlets)
  const clusterletConnections = useSelector(getClusterletConnections)
  const node = useSelector(getSelectedNode)
  const [profileAdded, setProfileAdded] = React.useState(null);


  useEffect(() => {

    const connectionLine = clusterletConnections.find(i => i.id === node.data.id)
    // console.log("connectionLine", connectionLine);

    const targetProfile = clusterlets.find(c => c.id === connectionLine.target)
    // console.log("target profile", targetProfile)

    const idOfProfile = constructIds.find(i => i.type === "profile").id

    if (targetProfile && targetProfile.type === idOfProfile) {
      setProfileAdded(true);
      const index = clusterlets.findIndex(i => i.id === targetProfile.id)
      dispatch(deleteClusterlet(index))

    }

  }, [node])


  const handleClose = () => {
    closePopUp(false)
  }

  const onActionComplete = (noUndoRedo) => {

    const connectionLine = clusterletConnections.find(i => i.id === node.data.id)
    dispatch(deleteClusterletConnection({ item: connectionLine, connetedTemplate: [] }))

    closePopUp(false)
  }

  return (
    <>
      <Dialog
        title={"Delete!"}
        handleClose={handleClose}
        open={true}
        actions={
          <>
            <Button
              onClick={handleClose}
              color="primary"
              variant="outlined"
              style={{ marginLeft: 10 }}
            >
              Cancel
            </Button>
            <Button
              onClick={onActionComplete}
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              Delete
            </Button>
          </>
        }
      >
        Do you want to delete this connection ?
        {profileAdded && (` Profile attached to this connection will also be deleted.`)}
      </Dialog>

    </>
  );
}